export default "__VITE_ASSET__CQVYuvf6__"